import ConditionType from './ConditionType'

const ChangedLessThanCondition: ConditionType = {
  value: 'changed less than',
  label: 'Changed Less Than',
  hasRHS: true,
  hasThreshold: true,
}

export default ChangedLessThanCondition
